import { render, staticRenderFns } from "./SchoolPayments.vue?vue&type=template&id=0729eb92&"
import script from "./SchoolPayments.vue?vue&type=script&lang=js&"
export * from "./SchoolPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports